import { modal } from 'components/Modals/ModalManager';
import router from 'next/router';
import { stores } from 'state/stores';
import { setAmplitudeUserId } from './events';
import { clearAllUserData } from './logout';
import toast from 'react-hot-toast';
import { themeState } from 'styleguide/theme';
import { t } from 'translations/t';
import { detectBrowserLanguage } from 'translations/detectUserLanguage';

const showCoachInviteModal = () => {
  const { invitingCoachData, acceptInvite, declineInvite } = stores.coach;

  if (invitingCoachData) {
    const { name, profilePic } = invitingCoachData;
    modal.showCoachInviteModal({
      coachName: name,
      coachProfilePic: profilePic,
      onAcceptInvite: async () => {
        await acceptInvite();

        router.push('/coach').then(() => {
          stores.account.coach_client_status = 'coached-active-plan';
          stores.coach.fetch();
        });
      },
      onDeclineInvite: declineInvite,
    });
  }
};

export const fetchUserContentAfterLogin = async (props?: {
  isCoachOnboardingFlow?: true;
  isNewUser?: true;
}) => {
  try {
    await stores.account.fetch();
  } catch (e) {
    clearAllUserData();
    router.push('/login').then(() => toast.error(t('web.fetchUserContent.error')));
    throw e;
  }

  Promise.all([
    stores.serverStorage.fetch(),
    stores.routines.fetch(),
    stores.exerciseTemplates.fetch(),
    stores.exerciseTemplateUnits.fetch(),
    stores.routineFolders.fetch(),
    stores.subscription.fetch(),
    stores.coach.fetch(),
    stores.trainer.fetch(),
    stores.userPreferences.fetch().then(() => {
      if (!props?.isNewUser) return;
      const browserLang = detectBrowserLanguage();
      if (browserLang) stores.userPreferences.update({ language: browserLang });
    }),
  ]).then(() => {
    const serverStorageThemePref = stores.serverStorage.hevyWebThemePreference;
    if (serverStorageThemePref) {
      themeState.onChangeTheme(serverStorageThemePref);
    }

    if (stores.coach.isInvitedByCoach && !props?.isCoachOnboardingFlow) {
      showCoachInviteModal();
    }
  });

  setAmplitudeUserId(stores.account.id);
};

export const fetchUserContentAfterLaunch = async () => {
  await Promise.all([
    stores.account.fetch(),
    stores.userPreferences.fetch(),
    stores.serverStorage.fetch(),
    stores.trainer.fetch(),
  ]).then(() => {
    const serverStorageThemePref = stores.serverStorage.hevyWebThemePreference;
    if (serverStorageThemePref) {
      themeState.onChangeTheme(serverStorageThemePref);
    }
  });

  stores.coach.fetch().then(() => {
    if (stores.coach.isInvitedByCoach) {
      showCoachInviteModal();
    }
  });

  if (stores.coach.isInvitedByCoach) {
    showCoachInviteModal();
  }

  setAmplitudeUserId(stores.account.id);

  stores.auth.authMigrate();
};
